import axios from "axios";

export const fetchAccountData = async (token) => {
  const headers = {
    Authorization: `Bearer ${token}`,
  };

  const [responseData, responseState] = await Promise.all([
    axios.get(`${process.env.REACT_APP_API_URL}/v1/user/me/`, { headers }),
    axios.get(`${process.env.REACT_APP_API_URL}/v1/sales/subscription/me/`, {
      headers,
    }),
  ]);

  return { responseData, responseState };
};
